import React from 'react';

function Logo(props){
    let logo = "";
    if(props.logo){
        let dealerUrl = props.dealerUrl;
        let checkHttp = dealerUrl.substring(0,4);
        if(checkHttp != 'http'){
            logo = <a target="_blank" href={"//"+ props.dealerUrl}><img className = "logo mt-3" src={props.logo} alt="Logo" /></a>;
        }else{
            logo = <a target="_blank" href={props.dealerUrl}><img className = "logo mt-3" src={props.logo} alt="Logo" /></a>;
        }
    }
    return (
        <div>{logo}</div>
    );
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo.js